import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useCallback, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useEmployee } from '../context/employee';

function SignInPage() {
    const { pathname } = useLocation();
    const { deviceToken, originalPath, SignIn } = useEmployee();

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [signingIn, setSigningIn] = useState(false);
    const [signInError, setSignInError] = useState('');

    const shouldDisableButton = useCallback(() => {
        return !username || !password;
    }, [username, password]);

    const signIn = useCallback(() => {
        setSigningIn(true);

        SignIn({ username, password }, (res) => {
            setSigningIn(false);

            if (res.status !== 200) {
                setSignInError(res.message);
            }
        });
    }, [username, password, SignIn]);

    const FooterContent = (
        <div>
            <Button
                label="Sign In"
                icon="pi pi-sign-in"
                disabled={shouldDisableButton()}
                onClick={signIn}
            />
        </div>
    );

    const to = originalPath ? originalPath : '/';

    if (deviceToken && to !== pathname) {
        return <Navigate to={to} />;
    }

    if (signInError) {
        return (
            <Card
                title="Sign In Error"
                subTitle="Your credentials were invalid."
                className="pageCard"
            >
                <p>{signInError}</p>

                <Button
                    onClick={() => {
                        setSignInError('');
                    }}
                >
                    Try Again
                </Button>
            </Card>
        );
    }

    if (signingIn) {
        return (
            <Card
                title="Signing In"
                subTitle="Please wait while we validate your credentials"
                className="pageCard"
            >
                <ProgressSpinner />
            </Card>
        );
    }

    return (
        <Card
            title="Sign In"
            subTitle="Access to the CFCE Online app"
            className="pageCard"
            footer={FooterContent}
        >
            <div className="card flex flex-wrap gap-3 p-fluid">
                <div className="flex-auto">
                    <label htmlFor="usernameId" className="font-bold block mb-2">
                        Username
                    </label>

                    <InputText
                        id="usernameId"
                        keyfilter={/^[a-zA-Z ]*$/}
                        maxLength={24}
                        value={username}
                        onChange={(e) => {
                            setUsername(e.target.value);
                        }}
                    />
                </div>
            </div>

            <div className="card flex flex-wrap gap-3 p-fluid">
                <div className="flex-auto">
                    <label htmlFor="passwordId" className="font-bold block mb-2">
                        Password
                    </label>

                    <Password
                        id="passwordId"
                        maxLength={64}
                        feedback={false}
                        toggleMask
                        value={password}
                        onChange={(e) => {
                            setPassword(e.target.value);
                        }}
                        onKeyUp={({ key }) => {
                            if (key === 'Enter' && !shouldDisableButton()) {
                                signIn();
                            }
                        }}
                    />
                </div>
            </div>
        </Card>
    );
}

export default SignInPage;
